export enum ItineraryType {
    ROUTE_ITINERARY = 'ROUTE_ITINERARY',
    STRUCTURED_ITINERARY = 'STRUCTURED_ITINERARY',
    UNSTRUCTURED_ITINERARY = 'UNSTRUCTURED_ITINERARY',
    UNKNOWN = 'UNKNOWN',
}
